import { AdaptedRefinements } from "../../components/RefinementField/types";
import { INITIAL_SLUG } from "./constants";
import { parseAsJson } from "./parseAsJson";
import { decodeString } from "./useSlugs";

export const decodeSlug = <T extends string>(slug: string) => {
  if (slug === INITIAL_SLUG) return null;
  return parseAsJson<AdaptedRefinements<T>>(decodeString)(slug);
};
